import {Component} from '@angular/core';

@Component({
    selector: 'app-filter-modal',
    template: `<div id="appendTarget" class="modal-body"></div>`,
})
export class FilterModalComponent {}
